import { useT } from '../i18n';

const ROWS = [
  ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
  ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
  ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'Ç'],
  ['Z', 'X', 'C', 'V', 'B', 'N', 'M', ',', '.', '?'],
  ['Á', 'À', 'Â', 'Ã', 'É', 'Ê', 'Í', 'Ó', 'Ô', 'Õ'],
  ['Ú', '!', '-'],
];

interface Props {
  value: string;
  onChange(value: string): void;
  onAddToSentence(): void;
  onSpeak(): void;
}

/**
 * Virtual keyboard with its own text field. The "apagar letra" key only edits
 * the typed text and is visually distinct from the sentence's "Apagar palavra".
 */
export function Keyboard({ value, onChange, onAddToSentence, onSpeak }: Props) {
  const t = useT();
  const type = (key: string) => onChange(value + key.toLowerCase());
  const hasText = value.trim().length > 0;

  return (
    <section className="keyboard" aria-label={t('keyboard')}>
      <div className="keyboard__field">
        <label htmlFor="typed-text" className="sr-only">
          {t('typedText')}
        </label>
        <input
          id="typed-text"
          className="keyboard__input"
          value={value}
          placeholder={t('typeHere')}
          autoComplete="off"
          autoCapitalize="sentences"
          spellCheck={false}
          // The on-screen keys are the main input; a physical keyboard also works.
          inputMode="none"
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && hasText) onAddToSentence();
          }}
        />
        <button type="button" className="btn btn--ghost" onClick={() => onChange('')} disabled={!value}>
          {t('clearTyped')}
        </button>
      </div>
      <div className="keyboard__keys">
        {ROWS.flat().map((key) => (
          <button key={key} type="button" className="key" onClick={() => type(key)}>
            {key}
          </button>
        ))}
        <button type="button" className="key key--backspace" onClick={() => onChange(value.slice(0, -1))} disabled={!value} aria-label={t('backspaceLetter')}>
          ← <span className="key__hint">{t('backspaceLetter')}</span>
        </button>
        <button type="button" className="key key--space" onClick={() => onChange(value + ' ')}>
          {t('space')}
        </button>
      </div>
      <div className="keyboard__actions">
        <button type="button" className="btn btn--primary btn--lg" onClick={onAddToSentence} disabled={!hasText}>
          ➕ {t('addToSentence')}
        </button>
        <button type="button" className="btn btn--secondary btn--lg" onClick={onSpeak} disabled={!hasText}>
          🔊 {t('speakTyped')}
        </button>
      </div>
    </section>
  );
}
